import React from 'react';
import { Navigate } from 'react-router-dom';
import ContextHelper from '../ContextHooks/ContextHelper';
import Cookies from 'js-cookie';

const RouteProtecter = ({ children, currentRoute }) => {
  const patientToken = Cookies.get('patient_token');
  const { currentUser } = ContextHelper();

  // Safe parse permissions
  const permissions =
    typeof currentUser?.permissions === 'string' ? JSON.parse(currentUser.permissions) : currentUser?.permissions || {};

  const hasPermission = (key) => permissions?.[key] === true || permissions?.[key] === 'true';

  if (!currentUser || Object.keys(currentUser).length === 0) {
    return <Navigate to="/login" replace />;
  }

  if (patientToken) {
    return <Navigate to="/patient-report" replace />;
  }

  const isAdmin = currentUser?.isadmin;
  const isSuperAdmin = currentUser?.type === 'superadmin';
  const isDoctor = currentUser?.type === 'Doctor';
  const isVerifier = currentUser?.type === 'verifier';

  // Admin-specific redirection
  if (isAdmin) {
    const adminRestrictedRoutes = [
      '/view-report',
      '/subscription-agent',
      '/report-upload',
      '/patient-registration',
      '/patient-billing',
    ];
    if (adminRestrictedRoutes.includes(currentRoute)) {
      return <Navigate to="/add-report" replace />;
    }
  }

  if (!isAdmin) {
    if (currentRoute === '/patient-registration' && !hasPermission('patient_registration')) {
      return <Navigate to="/view-report" replace />;
    }
    if (currentRoute === '/patient-billing' && !hasPermission('patient_billing')) {
      return <Navigate to="/view-report" replace />;
    }
    if (currentRoute === '/add-report') {
      return <Navigate to="/view-report" replace />;
    }
    if (currentRoute === '/create-user') {
      return <Navigate to="/view-report" replace />;
    }
    if (currentRoute === '/add-verifier') {
      return <Navigate to="/view-report" replace />;
    }
    if (currentRoute === '/verifier') {
      return <Navigate to="/view-report" replace />;
    }
  }

  // Special case for Doctor
  if (isDoctor && currentRoute === '/create-user') {
    return <Navigate to="/update-doctor" replace />;
  }

  if (isDoctor && currentRoute === '/add-verifier') {
    return <Navigate to="/update-doctor" replace />;
  }

  if (isDoctor && currentRoute === '/verifier') {
    return <Navigate to="/update-doctor" replace />;
  }

  if (isVerifier && currentRoute === '/create-user') {
    return <Navigate to="/view-report" replace />;
  }
  
  if (isAdmin && !hasPermission('add_verifier') && currentRoute === '/verifier') {
    return <Navigate to="/view-report" replace />;
  }
  if (isAdmin && !hasPermission('add_verifier') && currentRoute === '/add-verifier') {
    return <Navigate to="/view-report" replace />;
  }

  if (!hasPermission('add_verifier') && currentRoute === '/verifier') {
    return <Navigate to="/add-report" replace />;
  }

  if (!hasPermission('add_verifier') && currentRoute === '/add-verifier') {
    return <Navigate to="/add-report" replace />;
  }

  if (isSuperAdmin && currentRoute === '/add-verifier') {
    return <Navigate to="/view-report" replace />;
  }
  if (isSuperAdmin && currentRoute === '/verifier') {
    return <Navigate to="/view-report" replace />;
  }

  // Permission-based pages
  if (currentRoute === '/add-new-study' && !hasPermission('add_study')) {
    return <Navigate to="/view-report" replace />;
  }
  if (currentRoute === '/turnaround-time' && !hasPermission('turnaround_time') && !isSuperAdmin) {
    return <Navigate to="/" replace />;
  }
  if (currentRoute === '/business-revenue' && !hasPermission('business_revenue') && !isSuperAdmin) {
    return <Navigate to="/" replace />;
  }

  // Only superadmin can access /users and /subscription-admin
  if (currentRoute === '/users' && !isSuperAdmin) {
    return <Navigate to="/" replace />;
  }
  if (currentRoute === '/subscription-admin' && !isSuperAdmin) {
    return <Navigate to="/view-report" replace />;
  }

  return children;
};

export default RouteProtecter;
